import axios from 'axios';
import { mensagemRetorno } from '@/helper/funcoes';


export async function buscarDadosAtendimento(idAtendimento, atualizar) {
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}?atualizar=${atualizar}`
        );
        return response.data;
    } catch (error) {
        console.error('Erro na requisição:', error);
        throw error;
    }
}

export async function marcarChegadaPrestador(idAtendimento, idServicoAtendimento, dataHoraChegada) {
    try {
        const response = await axios.put(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}/servico/${idServicoAtendimento}/chegada/marcar`,
            { dataHoraChegada }
        );
        return mensagemRetorno(false, response, 'Chegada marcada com sucesso');
    } catch (error) {
        return mensagemRetorno(true, error, 'Erro ao enviar a marcação da chegada');
    }
}

export async function confirmarChegadaPrestador(idAtendimento, idServicoAtendimento, chegou) {
    try {
        const response = await axios.put(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}/servico/${idServicoAtendimento}/chegada/confirmar`,
            { chegou }
        );
        return mensagemRetorno(false, response, 'Confirmação de chegada enviada');
    } catch (error) {
        return mensagemRetorno(true, error, 'Erro ao enviar a confirmação da chegada');
    }
}

export async function salvarEndereco(idAtendimento, endereco) {
    try {
        const response = await axios.patch(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}/endereco`,
            endereco
        );
        return mensagemRetorno(false, response, 'Endereço enviado com sucesso');
    } catch (error) {
        return mensagemRetorno(true, error, 'Erro ao enviar o endereço');
    }
}

export async function enviarAnexos(idAtendimento, arquivos) {
    try {
        const response = await axios.post(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}/upload`,
            arquivos,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return mensagemRetorno(false, response, 'Anexo enviado com sucesso');
    } catch (error) {
        return mensagemRetorno(true, error, 'Erro ao enviar os anexos');
    }
}

export async function solicitarContato(idAtendimento, mensagem, cancelamento) {
    try {
        await axios.post(
            `${process.env.VUE_APP_URL_API}/client/atendimento/${idAtendimento}/contato`,
            { mensagem, cancelamento }
        );
        return { error: false, message: `Solicitação de ${cancelamento ? 'cancelamento' : 'contato'} enviada com sucesso`};
    } catch (error) {
        return { error: false, message: `Erro ao solicitar ${cancelamento ? 'cancelamento' : 'contato'} para a assistência`};
    }
}

/* export async function cancelarAtendimento(motivo) {
    const store = useAtendimentoStore();
    return await store.cancelarAtendimento(motivo);
} */